module.exports = {
  PUBLIC: "PUBLIC",
  PRIVATE: "PRIVATE",
  CREATE: "Create",
  UPDATE: "Update",
  THROW_ERROR: "THROW_ERROR",
  SUCCESS: "SUCCESS",
  WRA: "Writing Assignment",
  WRS: "Writing Submission",
  PK12: "PK-12",
  GEN: "General",
  HIED: "HigherEd",
  CONTENT: "Content",
  ASSIGNMENTS: "Assignments",
  TEACHER: "Teacher",
  STUDENT: "Student",
  INPROGRESS: "InProgress",
  CREATEDATDESC: "createdAt_DESC",
  INDEXDESC: "index_DESC",
  INDEXASC: "index_ASC",
  LISTINDEXASC: "listIndex_ASC",
  MONTHLY: "Monthly",
  QUARTERLY: "Quarterly",
  HALFYEARLY: "HalfYearly",
  YEARLY: "Yearly",
  INR: "INR",
  USD: "USD",
  READYFORQA: "ReadyForQA",
  COURSE: "Course",
  PUBLISHED: "Published",
  BOOK: "Book",
  OFFLINE: "Offline",
  REMOVED: "Removed",
  SUBSCRIPTION: "Subscription",
  ONETIMEPURCHASE: "OneTimePurchase",
  PROFESSIONAL: "Professional",
  HOBBY: "Hobby",
  AVA: "en-US-AvaMultilingualNeural",
  BRANDON: "en-US-BrandonMultilingualNeural",
  ADA: "en-GB-AdaMultilingualNeural",
  OLLIE: "en-GB-OllieMultilingualNeural",
  AVAVOICE: "https://staticassets.api.speech.microsoft.com/blobs/ttsvoice/Masterpieces/en-US-AvaMultilingual-General-Audio.wav",
  BRANDONVOICE: "https://staticassets.api.speech.microsoft.com/blobs/ttsvoice/Masterpieces/en-US-BrandonMultilingual-General-Audio.wav",
  ADAVOICE: "https://staticassets.api.speech.microsoft.com/blobs/ttsvoice/Masterpieces/en-GB-AdaMultilingual-General-Audio.wav",
  OLLIEVOICE: "https://staticassets.api.speech.microsoft.com/blobs/ttsvoice/Masterpieces/en-GB-OllieMultilingual-General-Audio.wav",
};
